import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-lizard': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M556.7 290.5c12.6 19.5 19.3 42.1 19.3 65.3v124.2h-224v-71.6l-99.8-38.8c-2.8-1.1-5.7-1.6-8.7-1.6h-131.6c-30.9 0-56-25.1-56-56 0-48.5 39.5-88 88-88h113.7l18.3-48h-196c-44.1 0-80-35.9-80-80v-8c0-30.9 25.1-56 56-56h293.9c24.5 0 47.1 12.3 60.4 32.8zM528 432v-76.2 0c0-11.7-5.2-29.3-11.6-39.1l-146.4-225.7c-4.4-6.9-12-10.9-20.1-10.9h-293.9c-4.4 0-8 3.6-8 8v8c0 17.6 14.4 32 32 32h213.5c25.2 0 42.6 25.3 33.6 48.8l-24.6 64.3c-7.1 18.5-25.1 30.9-44.8 30.9h-113.7c-22.1 0-40 17.9-40 40 0 4.4 3.6 8 8 8h131.6 0.1c7.4 0 19.1 2.2 26 4.9l99.8 38.8c18.6 7.2 30.6 24.8 30.6 44.7v23.6h128z'
      }
    ]
  }
})
